import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logo-192.png")